<template>
  <div id="AdvertMgmt" style="margin: 0 auto; background: white">
    <div ref="header" class="header-box">
      <div class="header-line">
        <span class="header-label">产品类型</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productType" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="product in productList" :key="product.productType" :label="product.productName" :value="product.productType"></el-option>
        </el-select>
        <span class="header-label">产品颜色</span>
        <el-select placeholder="产品类型" size="small" v-model="params.productColor" filterable>
          <el-option label="全部" value=""></el-option>
          <el-option v-for="color in colorList" :key="color.key" :label="color.name" :value="color.key"></el-option>
        </el-select>
        <span class="header-label">广告类型</span>
        <el-select placeholder="请选择" size="small" v-model="adViewType">
          <el-option label="全部" :value="100"></el-option>
          <el-option label="精准关键词" :value="1"></el-option>
          <el-option label="自动广告" :value="2"></el-option>
          <el-option label="紧密匹配" :value="3"></el-option>
          <el-option label="宽泛匹配" :value="4"></el-option>
          <el-option label="同类商品" :value="5"></el-option>
          <el-option label="关联商品" :value="6"></el-option>
        </el-select>
        <span class="header-label">广告状态</span>
        <el-select placeholder="请选择" size="small" v-model="params.adState">
          <el-option label="全部" value=""></el-option>
          <el-option label="已启用" value="已启用"></el-option>
          <el-option label="已暂停" value="已暂停"></el-option>
        </el-select>
        <span class="header-label">视图模式</span>
        <el-select placeholder="请选择" size="small" v-model="viewModel">
          <el-option label="精简" value="1"></el-option>
          <el-option label="全量" value="2"></el-option>
        </el-select>
        <span class="header-label">SKU</span>
        <el-input placeholder="请输入SKU" size="small" clearable v-model="sku"> </el-input>
        <el-button type="primary" size="small" @click="queryBtn">查询</el-button>
        <el-button type="primary" size="small" @click="batchEditBtn">批量修改</el-button>
        <!-- <el-button type="primary" size="small" @click="clearState">清除状态</el-button> -->
      </div>
    </div>
    <el-table ref="table" :data="tableData" stripe size="mini" :height="screenHeight" :highlight-current-row="true" @selection-change="handleSelectionChange" show-summary :summary-method="getSummaries" border>
      <el-table-column type="selection" width="55" align="center"> </el-table-column>
      <el-table-column prop="sku" label="" width="40px" align="right" type="expand" :key="10">
        <template slot-scope="listScope">
          <el-table class="child-table" :data="listScope.row.campainList" row-key="_id" lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" stripe size="mini" border default-expand-all style="width: 1752px; float: right">
            <el-table-column width="40px" align="right" type="expand" :key="10001">
              <template slot-scope="groupScope">
                <el-table v-if="groupScope.row.relateAdverts && groupScope.row.relateAdverts.length > 0" class="child-table" :data="groupScope.row.relateAdverts" row-key="_id" lazy :load="load" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" stripe size="mini" border style="width: 1711px; float: right">
                  <el-table-column prop="adTypeText" label="广告名称" width="100px" align="right"> </el-table-column>
                  <el-table-column prop="Bid" label="单价" width="80px" align="right">
                    <template slot-scope="scope">
                      <el-input v-model="scope.row.Bid" @change="onBidChange(scope.row)" size="mini"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column prop="recommandBid" label="推荐单价" width="40px" align="right">
                    <!-- <template v-slot="scope">
                      <div :class="getRecommandBidStyleClass(scope.row.relateAdvert)" @click="onRecommandBidClick(scope.row.relateAdvert)" style="cursor: pointer">{{ scope.row.relateAdvert && scope.row.relateAdvert.recommandBid }}</div>
                    </template> -->
                  </el-table-column>
                  <el-table-column label="操作" width="140px" align="right">
                    <template slot-scope="scope">
                      <div v-if="scope.row.isDetail">{{ scope.row.dateDes }}</div>
                      <template v-else>
                        <el-button type="text" size="small" @click="detailPage(scope.row)">投放词详情</el-button>
                        <el-button type="text" size="small" @click="searchKeydetailPage(scope.row)">搜索词详情</el-button>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column label="状态" width="50px" align="right">
                    <template slot-scope="scope">
                      <el-switch v-if="!scope.row.isDetail" v-model="scope.row.State" @change="onTargetStateChange(scope.row)" active-value="已启用" inactive-value="已暂停" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                    </template>
                  </el-table-column>
                  <el-table-column prop="CPC" label="CPC" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="Impressions" label="展现量" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="Clicks" label="点击量" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right">
                    <template slot-scope="scope">
                      {{ (scope.row["Click-through Rate"] * 100).toFixed(2) + "%" }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="Spend" label="花费" width="50px" align="right">
                    <template slot-scope="scope">
                      {{ Number(scope.row.Spend).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="Sales" label="销售额" width="50px" align="right">
                    <template slot-scope="scope">
                      {{ Number(scope.row.Sales).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="Orders" label="订单数" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="Units" label="销售数量" width="50px" align="right"> </el-table-column>
                  <el-table-column prop="Conversion Rate" label="转化率" width="50px" align="right">
                    <template slot-scope="scope">
                      {{ (scope.row["Conversion Rate"] * 100).toFixed(2) + "%" }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="ROAS" label="ROAS" width="50px" align="right"> </el-table-column>

                  <el-table-column label="标题" width="90px" align="right">
                    <div>
                      <div class="row-label">近90日</div>
                      <div class="row-label">近30日</div>
                      <div class="row-label">近14日</div>
                      <div>近7日</div>
                    </div>
                  </el-table-column>
                  <el-table-column label="CPC" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label">{{ scope.row.deliveryPerformance.last90DayCPC.toFixed(2) }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last30DayCPC.toFixed(2) }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last14DayCPC.toFixed(2) }}</div>
                        <div>{{ scope.row.deliveryPerformance.last7DayCPC.toFixed(2) }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="展现" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label">{{ scope.row.deliveryPerformance.last90DayImpressions }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last30DayImpressions }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last14DayImpressions }}</div>
                        <div>{{ scope.row.deliveryPerformance.last7DayImpressions }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="点击数" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label">{{ scope.row.deliveryPerformance.last90DayClicks }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last30DayClicks }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last14DayClicks }}</div>
                        <div>{{ scope.row.deliveryPerformance.last7DayClicks }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="订单数" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label">{{ scope.row.deliveryPerformance.last90DayOrders }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last30DayOrders }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last14DayOrders }}</div>
                        <div>{{ scope.row.deliveryPerformance.last7DayOrders }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="商品数" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label">{{ scope.row.deliveryPerformance.last90DayUnits }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last30DayUnits }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last14DayUnits }}</div>
                        <div>{{ scope.row.deliveryPerformance.last7DayUnits }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="点击率" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label">{{ (scope.row.deliveryPerformance.last90DayClickRate * 100).toFixed(2) + "%" }}</div>
                        <div class="row-label">{{ (scope.row.deliveryPerformance.last30DayClickRate * 100).toFixed(2) + "%" }}</div>
                        <div class="row-label">{{ (scope.row.deliveryPerformance.last14DayClickRate * 100).toFixed(2) + "%" }}</div>
                        <div>{{ (scope.row.deliveryPerformance.last7DayClickRate * 100).toFixed(2) + "%" }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="转化率" width="60px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row, 'last90DayConversionRate')">{{ (scope.row.deliveryPerformance.last90DayConversionRate * 100).toFixed(2) + "%" }}</div>
                        <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row, 'last30DayConversionRate')">{{ (scope.row.deliveryPerformance.last30DayConversionRate * 100).toFixed(2) + "%" }}</div>
                        <div class="row-label" :class="getDeliveryConversionRateStyleClass(scope.row, 'last14DayConversionRate')">{{ (scope.row.deliveryPerformance.last14DayConversionRate * 100).toFixed(2) + "%" }}</div>
                        <div :class="getDeliveryConversionRateStyleClass(scope.row, 'last7DayConversionRate')">{{ (scope.row.deliveryPerformance.last7DayConversionRate * 100).toFixed(2) + "%" }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="花费" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label">{{ scope.row.deliveryPerformance.last90DaySpend.toFixed(2) }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last30DaySpend.toFixed(2) }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last14DaySpend.toFixed(2) }}</div>
                        <div>{{ scope.row.deliveryPerformance.last7DaySpend.toFixed(2) }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="销售" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label">{{ scope.row.deliveryPerformance.last90DaySales.toFixed(2) }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last30DaySales.toFixed(2) }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last14DaySales.toFixed(2) }}</div>
                        <div>{{ scope.row.deliveryPerformance.last7DaySales.toFixed(2) }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="ROAS" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label" :class="getDeliveryROASStyleClass(scope.row, 'last90DayROAS')">{{ scope.row.deliveryPerformance.last90DayROAS.toFixed(2) }}</div>
                        <div class="row-label" :class="getDeliveryROASStyleClass(scope.row, 'last30DayROAS')">{{ scope.row.deliveryPerformance.last30DayROAS.toFixed(2) }}</div>
                        <div class="row-label" :class="getDeliveryROASStyleClass(scope.row, 'last14DayROAS')">{{ scope.row.deliveryPerformance.last14DayROAS.toFixed(2) }}</div>
                        <div :class="getDeliveryROASStyleClass(scope.row, 'last7DayROAS')">{{ scope.row.deliveryPerformance.last7DayROAS.toFixed(2) }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="CPS" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label">{{ scope.row.deliveryPerformance.last90DayCPS.toFixed(2) }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last30DayCPS.toFixed(2) }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last14DayCPS.toFixed(2) }}</div>
                        <div>{{ scope.row.deliveryPerformance.last7DayCPS.toFixed(2) }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="毛利" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label">{{ scope.row.deliveryPerformance.last90DayGrossIncome.toFixed(2) }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last30DayGrossIncome.toFixed(2) }}</div>
                        <div class="row-label">{{ scope.row.deliveryPerformance.last14DayGrossIncome.toFixed(2) }}</div>
                        <div>{{ scope.row.deliveryPerformance.last7DayGrossIncome.toFixed(2) }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="净利" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last90DayNetIncome')">{{ scope.row.deliveryPerformance.last90DayNetIncome.toFixed(2) }}</div>
                        <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last30DayNetIncome')">{{ scope.row.deliveryPerformance.last30DayNetIncome.toFixed(2) }}</div>
                        <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last14DayNetIncome')">{{ scope.row.deliveryPerformance.last14DayNetIncome.toFixed(2) }}</div>
                        <div :class="getDeliveryNetIncomeStyleClass(scope.row, 'last7DayNetIncome')">{{ scope.row.deliveryPerformance.last7DayNetIncome.toFixed(2) }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="ROI" width="50px" align="right">
                    <template slot-scope="scope">
                      <div v-if="Object.keys(scope.row.deliveryPerformance).length !== 0">
                        <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last90DayROI')">{{ scope.row.deliveryPerformance.last90DayROI.toFixed(2) }}</div>
                        <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last30DayROI')">{{ scope.row.deliveryPerformance.last30DayROI.toFixed(2) }}</div>
                        <div class="row-label" :class="getDeliveryNetIncomeStyleClass(scope.row, 'last14DayROI')">{{ scope.row.deliveryPerformance.last14DayROI.toFixed(2) }}</div>
                        <div :class="getDeliveryNetIncomeStyleClass(scope.row, 'last7DayROI')">{{ scope.row.deliveryPerformance.last7DayROI.toFixed(2) }}</div>
                      </div>
                      <div v-else>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div class="row-label"></div>
                        <div></div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>

            <el-table-column prop="adTypeText" label="广告名称" width="100px" align="right"> </el-table-column>
            <!-- <el-table-column prop="Daily Budget" label="日预算" width="80px" align="right">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.isDetail" v-model="scope.row['Daily Budget']" @change="onDailyBudgetChange(scope.row)" size="mini"></el-input>
              </template>
            </el-table-column> -->
            <el-table-column prop="Bid" label="单价" width="80px" align="right">
              <template slot-scope="scope">
                <el-input v-if="!scope.row.isDetail && scope.row.relateAdvert" v-model="scope.row.relateAdvert.Bid" @change="onBidChange(scope.row.relateAdvert)" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="recommandBid" label="推荐单价" width="40px" align="right">
              <template v-slot="scope">
                <div :class="getRecommandBidStyleClass(scope.row.relateAdvert)" @click="onRecommandBidClick(scope.row.relateAdvert)" style="cursor: pointer">{{ scope.row.relateAdvert && scope.row.relateAdvert.recommandBid }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140px" align="right">
              <template slot-scope="scope">
                <div v-if="scope.row.isDetail">{{ scope.row.dateDes }}</div>
                <template v-else>
                  <el-button type="text" size="small" @click="detailPage(scope.row)">投放词详情</el-button>
                  <el-button type="text" size="small" @click="searchKeydetailPage(scope.row)">搜索词详情</el-button>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="50px" align="right">
              <template slot-scope="scope">
                <el-switch v-if="!scope.row.isDetail" v-model="scope.row.State" @change="onStateChange(scope.row, listScope.row)" active-value="已启用" inactive-value="已暂停" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="CPC" label="CPC" width="50px" align="right"> </el-table-column>
            <el-table-column prop="Impressions" label="展现量" width="50px" align="right"> </el-table-column>
            <el-table-column prop="Clicks" label="点击量" width="50px" align="right"> </el-table-column>
            <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right">
              <template slot-scope="scope">
                {{ (scope.row["Click-through Rate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="Spend" label="花费" width="50px" align="right">
              <template slot-scope="scope">
                {{ Number(scope.row.Spend).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="Sales" label="销售额" width="50px" align="right">
              <template slot-scope="scope">
                {{ Number(scope.row.Sales).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="Orders" label="订单数" width="50px" align="right"> </el-table-column>
            <el-table-column prop="Units" label="销售数量" width="50px" align="right"> </el-table-column>
            <el-table-column prop="Conversion Rate" label="转化率" width="50px" align="right">
              <template slot-scope="scope">
                {{ (scope.row["Conversion Rate"] * 100).toFixed(2) + "%" }}
              </template>
            </el-table-column>
            <el-table-column prop="ROAS" label="ROAS" width="50px" align="right"> </el-table-column>
            <el-table-column> </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="sku" label="SKU" width="180px" align="right" :key="11" sortable> </el-table-column>
      <!-- <el-table-column prop="asin" label="Asin" width="60px" align="right" sortable>
      </el-table-column> -->
      <el-table-column prop="productName" label="名称" width="70px" align="right" v-if="viewModel == 2" :key="12" sortable> </el-table-column>
      <el-table-column prop="model" label="机型" width="60px" align="right" v-if="viewModel == 2" :key="13" sortable> </el-table-column>
      <el-table-column prop="productColorName" label="颜色" width="60px" align="right" v-if="viewModel == 2" :key="14" sortable> </el-table-column>
      <el-table-column prop="speed" label="增速" width="40px" align="right" :key="15" sortable> </el-table-column>
      <!-- <el-table-column prop="inventoryAge0To90Days" label="0~90日库存" width="40px" align="right" sortable>
      </el-table-column>
      <el-table-column prop="inventoryAge91To180Days" label="91~180日库存" width="40px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getInventoryAgeStyleClass(scope.row.inventoryAge91To180Days)">{{ scope.row.inventoryAge91To180Days }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="sellThrough" label="售出率" width="40px" align="right" sortable>
        <template v-slot="scope">
          <div :class="getSellThroughStyleClass(scope.row.sellThrough)">{{ scope.row.sellThrough }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="unitsShippedT90" label="90日订单" width="60px" align="right" sortable>
      </el-table-column> -->
      <el-table-column prop="inventoryCount" label="库存" width="40px" align="right" :key="16" sortable> </el-table-column>
      <el-table-column prop="availableQuantity" label="可用" width="40px" style="color: green" align="right" :key="17" sortable>
        <template v-slot="scope">
          <div class="greenText">{{ scope.row.availableQuantity }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="reservedQuantity" label="预留" width="40px" style="color: greenyellow" align="right" :key="18" sortable>
        <template v-slot="scope">
          <div class="greenYellowText">{{ scope.row.reservedQuantity }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="inboundQuantity" label="入库" width="40px" align="right" :key="19" sortable> </el-table-column>
      <el-table-column prop="availableIn1WeekCount" label="1周内上架" width="40px" align="right" :key="81151" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.availableIn1WeekCount > 0 ? scope.row.availableIn1WeekCount : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableIn2WeekCount" label="2周内上架" width="40px" align="right" :key="81152" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.availableIn2WeekCount > 0 ? scope.row.availableIn2WeekCount : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableIn3WeekCount" label="3周内上架" width="40px" align="right" :key="81153" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.availableIn3WeekCount > 0 ? scope.row.availableIn3WeekCount : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableIn4WeekCount" label="4周内上架" width="40px" align="right" :key="81154" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.availableIn4WeekCount > 0 ? scope.row.availableIn4WeekCount : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableIn5WeekCount" label="5周内上架" width="40px" align="right" :key="81155" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.availableIn5WeekCount > 0 ? scope.row.availableIn5WeekCount : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableOver5WeekCount" label="超5周上架" width="40px" align="right" :key="81156" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.availableOver5WeekCount > 0 ? scope.row.availableOver5WeekCount : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="inboundWorking" label="处理中" width="40px" align="right" v-if="viewModel == 2" :key="110" sortable> </el-table-column>
      <el-table-column prop="inboundShipped" label="已发货" width="40px" align="right" v-if="viewModel == 2" :key="111" sortable> </el-table-column>
      <el-table-column prop="inboundReceived" label="正在接收" width="40px" style="color: goldenrod" align="right" :key="112" sortable>
        <template v-slot="scope">
          <div class="yellowText">{{ scope.row.inboundReceived }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="inventoryDay" label="库存天数" width="55px" align="right" :key="113" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.inventoryDay)">{{ scope.row.inventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableInventoryDay" label="可用库存天数" width="55px" align="right" :key="114" sortable>
        <template v-slot="scope">
          <div :class="getInventoryDayStyleClass(scope.row.availableInventoryDay)">{{ scope.row.availableInventoryDay }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalVisit" label="合计访客" width="55px" align="right" :key="115" sortable> </el-table-column>
      <el-table-column prop="orderRate" label="转化率" width="50px" align="right" :key="116" sortable>
        <template v-slot="scope">
          <div>{{ scope.row.orderRate >= 0 ? (Math.round(scope.row.orderRate * 10000) / 100).toFixed(2) + "%" : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalOrder" label="合计订单" width="55px" align="right" :key="117" sortable> </el-table-column>
      <el-table-column prop="last7DayCount" label="七日订单" width="55px" align="right" :key="118" sortable> </el-table-column>
      <el-table-column prop="lastDayCount" label="昨日订单" width="55px" align="right" :key="1181" sortable> </el-table-column>
      <el-table-column prop="price" label="价格" width="40px" align="right" :key="119" sortable> </el-table-column>
      <el-table-column prop="majorLevel" label="等级" width="40px" align="right" :key="120" sortable>
        <template v-slot="scope">
          <div :class="getMajorLevelStyleClass(scope.row)">{{ scope.row.majorLevel > 0 ? scope.row.majorLevel : "" }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="State" label="推荐状态" width="80px" align="right" :key="1200" sortable>
        <template v-slot="scope">
          <div :class="getRecommendStyleClass(scope.row)">{{ getRecommendState(scope.row) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="50px" align="right" :key="121" sortable>
        <template slot-scope="scope">
          <el-switch v-model="scope.row.State" @change="onProductStateChange(scope.row)" active-value="已启用" inactive-value="已暂停" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="50px" :key="122">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="productDetail(scope.row)">详情</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="CPC" label="CPC" width="50px" align="right" :key="123" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.CPC).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Impressions" label="展现量" width="50px" align="right" :key="124" sortable> </el-table-column>
      <el-table-column prop="Clicks" label="点击量" width="50px" align="right" :key="125" sortable> </el-table-column>
      <el-table-column prop="Click-through Rate" label="点击率" width="50px" align="right" :key="126" sortable>
        <template slot-scope="scope">
          {{ (scope.row["Click-through Rate"] * 100).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="Spend" label="花费" width="50px" align="right" :key="127" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.Spend).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Sales" label="销售额" width="50px" align="right" :key="128" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.Sales).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="Orders" label="订单数" width="50px" align="right" :key="129" sortable> </el-table-column>
      <el-table-column prop="Units" label="销售数量" width="50px" align="right" :key="130" sortable> </el-table-column>
      <el-table-column prop="Conversion Rate" label="转化率" width="50px" align="right" :key="131" sortable>
        <template slot-scope="scope">
          {{ (scope.row["Conversion Rate"] * 100).toFixed(2) + "%" }}
        </template>
      </el-table-column>
      <el-table-column prop="ROAS" label="ROAS" width="50px" align="right" :key="132" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.ROAS).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="cps" label="CPS" width="50px" align="right" :key="1321232" sortable>
        <template slot-scope="scope">
          {{ Number(scope.row.cps).toFixed(2) }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination ref="pageNav" layout="prev,pager, next" background prev-text="上一页" next-text="下一页" :page-count="pageCount" :page-size="params.pageSize" :total="total" @prev-click="prevBtnClick" @next-click="nextBtnClick" @current-change="curBtnClick"> </el-pagination>

    <el-dialog title="批量修改" :visible.sync="batchEditDialogVisible">
      <div class="dialog-content">
        <el-form ref="batchEditForm" :rules="rules" label-width="80px">
          <el-form-item label="紧密匹配">
            <el-select placeholder="请选择" size="small" v-model="batchEditForm.opreateType">
              <el-option label="覆盖" :value="1"></el-option>
              <el-option label="增加" :value="2"></el-option>
              <el-option label="减少" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="紧密匹配">
            <el-input type="number" placeholder="请输入" v-model="batchEditForm.closeBid"> </el-input>
          </el-form-item>
          <el-form-item label="宽泛匹配">
            <el-input type="number" placeholder="请输入" v-model="batchEditForm.looseBid"> </el-input>
          </el-form-item>
          <el-form-item label="同类商品">
            <el-input type="number" placeholder="请输入" v-model="batchEditForm.substitutesBid"> </el-input>
          </el-form-item>
          <el-form-item label="关联商品">
            <el-input type="number" placeholder="请输入" v-model="batchEditForm.complementsBid"> </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchEditDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitBatchEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";
import { products, activeProducts, colors, models } from "../../utils/constant.js";
export default {
  data() {
    var valiPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入出价"));
      } else if (value < 0.1) {
        callback(new Error("出价过低，请重新出价"));
      } else {
        callback();
      }
    };
    return {
      screenHeight: document.body.clientHeight - 64 - 54 - 68,
      products: activeProducts,
      total: 0,
      pageCount: 1,
      sku: "",
      productType: "1",
      productColor: "",
      advertData: [],
      productList: activeProducts,
      colorList: colors,
      viewModel: "1",
      adViewType: 100,
      multipleSelection: [],
      batchEditDialogVisible: false,
      batchEditForm: {
        closeBid: 0.3,
        looseBid: 0.3,
        complementsBid: 0.2,
        substitutesBid: 0.2,
        opreateType: 1,
      },
      batchEditList: [],
      rules: {
        closeBid: [{ validator: valiPass, trigger: "blur" }],
        looseBid: [{ validator: valiPass, trigger: "blur" }],
        substitutesBid: [{ validator: valiPass, trigger: "blur" }],
        complementsBid: [{ validator: valiPass, trigger: "blur" }],
      },
      params: { pageSize: 200, sku: this.sku, typeList: "1|2|3|4", date: new Date().format("yyyy-MM-dd"), beginIndex: 0, productType: "2", productColor: "", adState: "已启用" },
    };
  },
  components: {},
  watch: {
    "params.productType": {
      handler: function (newValue, oldValue) {
        let parentProduct = this.productList.find(pd => pd.productType == newValue);
        let checkColors = Array.isArray(parentProduct.checkColors) ? parentProduct.checkColors : JSON.parse(parentProduct.checkColors);
        this.colorList = [];
        colors.forEach(color => checkColors.includes(color.key) && this.colorList.push(color));
      },
    },
    products: {
      handler: function (newValue, oldValue) {
        let product = this.products && this.products.length > 0 ? this.products[0] : null;
        if (!product) {
          return;
        }

        this.params.productType = product.productType;
        // if (product.shopType == 1 || product.shopType == 2) {
        //   this.params.productColor = product.defaultColor;
        // }

        this.getAdvertData();
      },
      deep: true,
    },
  },
  mounted() {
    this.$eventBus.$on("resize", this.calculateHeight);

    let product = this.products && this.products.length > 0 ? this.products[0] : null;
    if (!product) {
      return;
    }

    this.params.productType = product.productType;
    if (product.shopType == 1 || product.shopType == 2) {
      this.params.productColor = product.defaultColor;
    }

    this.getAdvertData();
  },
  beforeDestroy() {
    this.$eventBus.$off("resize", this.calculateHeight);
  },
  methods: {
    calculateHeight() {
      this.screenHeight = document.body.clientHeight - 64 - 54 - 68;
    },
    clearState() {
      this.advertData.forEach(item => {
        let campainList = item.campainList;
        campainList.forEach(campain => {
          if (campain.Operation != "") {
            let params = {
              id: campain._id,
              Operation: "",
            };
            requestModules.updateProductAdvert(params).then(res => {});
          }
          if (campain.relateAdvert.Operation != "") {
            let params = {
              id: campain.relateAdvert._id,
              Operation: "",
            };
            requestModules.updateProductAdvert(params).then(res => {});
          }
        });
      });
    },
    handleSelectionChange(checkedList) {
      this.multipleSelection = checkedList;
    },
    batchEditBtn() {
      this.batchEditDialogVisible = true;
    },
    submitBatchEdit() {
      this.$confirm("是否确认批量修改出价?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.batchEditDialogVisible = false;
          let list = [];
          this.multipleSelection.forEach(ad => {
            let adInfo = this.tableData.find(item => ad._id == item._id);
            let campainAd = adInfo.campainList.find(item => item.advertType == 2);
            let relateAds = campainAd ? campainAd.relateAdverts : null;
            relateAds &&
              relateAds.forEach(relateAd => {
                let params = {
                  id: relateAd._id,
                  target: relateAd["Product Targeting Expression"],
                  bid: parseFloat(relateAd.Bid),
                };
                let target = relateAd["Product Targeting Expression"];
                if (this.batchEditForm.opreateType == 1) {
                  target == "close-match" && (params.bid = parseFloat(this.batchEditForm.closeBid));
                  target == "loose-match" && (params.bid = parseFloat(this.batchEditForm.looseBid));
                  target == "substitutes" && (params.bid = parseFloat(this.batchEditForm.substitutesBid));
                  target == "complements" && (params.bid = parseFloat(this.batchEditForm.complementsBid));
                } else if (this.batchEditForm.opreateType == 2) {
                  target == "close-match" && (params.bid += parseFloat(this.batchEditForm.closeBid));
                  target == "loose-match" && (params.bid += parseFloat(this.batchEditForm.looseBid));
                  target == "substitutes" && (params.bid += parseFloat(this.batchEditForm.substitutesBid));
                  target == "complements" && (params.bid += parseFloat(this.batchEditForm.complementsBid));
                } else if (this.batchEditForm.opreateType == 3) {
                  target == "close-match" && (params.bid -= parseFloat(this.batchEditForm.closeBid));
                  target == "loose-match" && (params.bid -= parseFloat(this.batchEditForm.looseBid));
                  target == "substitutes" && (params.bid -= parseFloat(this.batchEditForm.substitutesBid));
                  target == "complements" && (params.bid -= parseFloat(this.batchEditForm.complementsBid));
                }

                if (!params.bid) {
                  console.log(params.bid);
                }

                params.bid = parseFloat(params.bid.toFixed(2));

                list.push(params);
              });
          });
          this.batchEditList = list;
          console.log(this.batchEditList);

          let params = {
            batchEditList: JSON.stringify(this.batchEditList),
          };
          requestModules.batchUpdateProductAdvert(params).then(res => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.getAdvertData();
          });
        })
        .catch(err => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    onTargetStateChange(row) {
      let params = {
        id: row._id,
        State: row.State,
      };
      requestModules.updateProductAdvert(params).then(res => {
        this.$message({
          type: "success",
          message: "修改成功!",
        });
      });
    },
    onStateChange(row, listRow) {
      let params = {
        id: row._id,
        State: row.State,
      };
      requestModules.updateProductAdvert(params).then(res => {
        this.$message({
          type: "success",
          message: "修改成功!",
        });
      });

      let state = "已暂停";
      listRow.campainList.forEach(advert => {
        advert.State == "已启用" && (state = "已启用");
      });
      listRow.State = state;
    },
    onProductStateChange(row) {
      let params = {
        id: row._id,
        State: row.State,
      };
      requestModules.updateProductAdvert(params).then(res => {
        let campainList = row.campainList;
        campainList.forEach(campain => {
          campain.State = row.State;
          let params2 = {
            id: campain._id,
            State: row.State,
          };
          requestModules.updateProductAdvert(params2).then(res => {});

          campain.relateAdverts &&
            campain.relateAdverts.forEach(ad => {
              ad.State = row.State;
              let params3 = {
                id: ad._id,
                State: row.State,
              };
              requestModules.updateProductAdvert(params3).then(res => {});
            });
        });
        this.$message({
          type: "success",
          message: "修改成功!",
        });
      });
    },
    onDailyBudgetChange(row) {
      this.$confirm("是否确认修改每日预算?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.advertData.forEach(item => {
          //   let campainList = item.campainList;
          //   // let advert = campainList.find(ad => ad.advertType == 2);
          //   campainList.forEach(campain => {
          //     if (campain['Daily Budget'] < 5) {
          //       let params = {
          //         id: campain._id,
          //         "Daily Budget": 5
          //       }
          //       requestModules.updateProductAdvert(params).then(res => { });
          //     }
          //   })

          // })

          let params = {
            id: row._id,
            "Daily Budget": row["Daily Budget"],
          };
          requestModules.updateProductAdvert(params).then(res => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    onBidChange(row) {
      this.$confirm("是否确认修改单次点击价?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.advertData.forEach(item => {
          //   let campainList = item.campainList;
          //   let advert = campainList.find(ad => ad.advertType == 2);
          //   if (advert.State == "已启用") {
          //     let params = {
          //       id: advert.relateAdvert._id,
          //       Bid: Number(advert.relateAdvert.Bid) + 0.05
          //     }
          //     requestModules.updateProductAdvert(params).then(res => { });
          //   }

          //   advert = campainList.find(ad => ad.advertType == 3);
          //   if (advert.State == "已启用") {
          //     let params = {
          //       id: advert.relateAdvert._id,
          //       Bid: Number(advert.relateAdvert.Bid) + 0.05
          //     }
          //     requestModules.updateProductAdvert(params).then(res => { });
          //   }
          // })

          let params = {
            id: row._id,
            Bid: row.Bid,
          };
          requestModules.updateProductAdvert(params).then(res => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    onRecommandBidClick(row) {
      this.$confirm("是否确认修改单次点击价格?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: row._id,
            Bid: row.recommandBid,
          };
          requestModules.updateProductAdvert(params).then(res => {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            row.Bid = row.recommandBid;
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    detailPage(row) {
      window.open("/client/deliveryKeywordMgmt?asin=" + row.asin);
    },
    searchKeydetailPage(row) {
      window.open("/client/searchKeywordMgmt?asin=" + row.asin);
    },
    queryBtn() {
      this.getAdvertData();
    },
    getAdvertData() {
      // !this.params.productColor && (this.params.productColor = "黑色");
      // !this.params.productType && (this.params.productType = 1);

      requestModules.fetchProductAdverts(this.params).then(res => {
        this.advertData = res.ldata;
        this.total = res.total;
        this.pageCount = Math.ceil(this.total / this.params.pageSize) || 1;
      });
    },
    getInventoryDayStyleClass(inventoryDay) {
      let styleClass = "";
      inventoryDay <= 15 && (styleClass = "redBg");
      inventoryDay > 15 && inventoryDay <= 30 && (styleClass = "yellowBg");
      inventoryDay > 30 && inventoryDay <= 90 && (styleClass = "greenBg");
      inventoryDay > 90 && (styleClass = "redText");
      return styleClass;
    },
    getRecommendStyleClass(row) {
      let state = this.getRecommendState(row);
      let styleClass = "";
      if (state != row.State) {
        state == "enabled" && (styleClass = "greenBg");
        state == "enabled" && row.price > 8.5 && (styleClass = "yellowBg");
        state == "paused" && (styleClass = "redBg");
        state == "paused" && row.price < 6.5 && (styleClass = "yellowBg");
      }
      return styleClass;
    },
    getMajorLevelStyleClass(row) {
      let styleClass = "";
      row.majorLevel == "1" && (styleClass = "greenBg");
      row.majorLevel == "2" && (styleClass = "redBg");
      return styleClass;
    },
    getRecommendState(row) {
      let state = "paused";
      let { totalVisit, orderRate, totalCount, availableInventoryDay, inventoryDay, inventoryCount, reservedQuantity, speed } = { ...row };
      if (availableInventoryDay >= 90 && Number(inventoryCount) + Number(reservedQuantity) > 30) {
        state = "enabled";
      } else {
        if (speed < 0 && availableInventoryDay >= 60 && orderRate >= 0.08 && totalVisit > 100) {
          state = "enabled";
        }
      }
      // inventoryDay == 10000 && inventoryCount > 10 && (state = "enabled");
      // availableInventoryDay >= 90 && orderRate >= 0.08 && totalVisit < 100 && (state = "enabled");
      return state;
    },
    getRecommandBidStyleClass(row) {
      let styleClass = "";
      if (!row) {
        return;
      }
      row.recommandBid > row.Bid && (styleClass = "greenBg");
      row.recommandBid < row.Bid && (styleClass = "redBg");
      // row.recommandState == "2" && (styleClass = "redBg");
      return styleClass;
    },
    getDeliveryConversionRateStyleClass(row, key) {
      if (!row || !row.deliveryPerformance) {
        return "";
      }
      let conversionRate = row.deliveryPerformance[key];
      let styleClass = "";
      conversionRate >= 0.15 && (styleClass = "greenBg");
      conversionRate < 0.1 && (styleClass = "redBg");
      return styleClass;
    },
    getDeliveryROASStyleClass(row, key) {
      if (!row || !row.deliveryPerformance) {
        return "";
      }
      let roas = row.deliveryPerformance[key];
      let styleClass = "";
      roas >= 3 && (styleClass = "greenBg");
      roas < 1 && (styleClass = "redBg");
      return styleClass;
    },
    getDeliveryNetIncomeStyleClass(row, key) {
      if (!row || !row.deliveryPerformance) {
        return "";
      }
      let netIncome = row.deliveryPerformance[key];
      let styleClass = "";
      netIncome > 0 && (styleClass = "greenBg");
      netIncome < 0 && (styleClass = "redBg");
      return styleClass;
    },
    productDetail(row) {
      window.open("/client/productDetail?asin=" + row.asin);
    },
    prevBtnClick() {
      this.handlerPageChange();
    },
    nextBtnClick() {
      this.handlerPageChange();
    },
    curBtnClick() {
      this.handlerPageChange();
    },
    handlerPageChange() {
      let pageNav = this.$refs.pageNav;
      // let lastEmittedPage = pageNav.lastEmittedPage;
      let internalCurrentPage = pageNav.internalCurrentPage;
      this.params.beginIndex = (internalCurrentPage - 1) * this.params.pageSize;
      this.getAdvertData();
    },
    load(tree, treeNode, resolve) {
      let params = { pageSize: 100, campaignName: tree["Campaign Name (Informational only)"], adGroupName: tree["Ad Group Name (Informational only)"] };
      requestModules.fetchDetailProductAds(params).then(res => {
        let list = res.ldata;
        list.forEach(item => {
          item.Bid = "";
          item.relateAdvert = {};
          item.isDetail = true;
        });
        resolve(list);
      });
    },
    getSummaries(param) {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
      const { columns, data } = param;
      const sums = [];
      let totalVisit = 0;
      let totalCount = 0;
      let totalOrder = 0;
      let impressions = 0;
      let clicks = 0;
      let orders = 0;
      let spend = 0;
      let sales = 0;
      const skipSumProps = new Set(["orderRate", "Click-through Rate", "Conversion Rate", "ROAS", "CPC", "cps", "price", "majorLevel", "speed", "inventoryDay", "availableInventoryDay"]);

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (!column.property || skipSumProps.has(column.property)) {
          sums[index] = "";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            return !isNaN(value) ? prev + value : prev;
          }, 0);
        } else {
          sums[index] = "";
        }
        column.property === "totalVisit" && (totalVisit = sums[index]);
        column.property === "totalCount" && (totalCount = sums[index]);
        column.property === "totalOrder" && (totalOrder = sums[index]);
        column.property === "Impressions" && (impressions = sums[index]);
        column.property === "Clicks" && (clicks = sums[index]);
        column.property === "Orders" && (orders = sums[index]);
        column.property === "Spend" && (spend = sums[index]);
        column.property === "Sales" && (sales = sums[index]);
      });

      if (!totalCount) {
        totalCount = data.reduce((sum, item) => sum + (Number(item.totalCount) || 0), 0);
        totalOrder = data.reduce((sum, item) => sum + (Number(item.totalOrder) || 0), 0);
      }

      columns.forEach((column, index) => {
        if (column.property === "orderRate") {
          sums[index] = totalVisit > 0 ? (Math.round((totalOrder / totalVisit) * 10000) / 100).toFixed(2) + "%" : "";
        }
        if (column.property === "Click-through Rate") {
          sums[index] = impressions > 0 ? ((clicks / impressions) * 100).toFixed(2) + "%" : "";
        }
        if (column.property === "Conversion Rate") {
          sums[index] = clicks > 0 ? ((orders / clicks) * 100).toFixed(2) + "%" : "";
        }
        if (column.property === "ROAS") {
          sums[index] = spend > 0 ? (sales / spend).toFixed(2) : "";
        }
        if (column.property === "CPC") {
          sums[index] = clicks > 0 ? (spend / clicks).toFixed(2) : "";
        }
        if (column.property === "cps") {
          sums[index] = orders > 0 ? (spend / orders).toFixed(2) : "";
        }
        if ((column.property === "Spend" || column.property === "Sales") && sums[index] !== "") {
          sums[index] = Number(sums[index]).toFixed(2);
        }
      });
      return sums;
    },
  },
  computed: {
    tableData() {
      let list = [];
      this.advertData.forEach(ad => {
        let pdInfo = {
          inventoryCount: ad.inventoryCount,
          reservedQuantity: ad.reservedQuantity,
          inboundQuantity: ad.inboundQuantity,
          inventoryDay: ad.inventoryDay,
          availableInventoryDay: ad.availableInventoryDay,
          inventoryDay: ad.inventoryDay,
          availableQuantity: ad.availableQuantity,
          inventoryCount: ad.inventoryCount,
          totalVisit: ad.totalVisit,
          totalOrder: ad.totalOrder,
          totalCount: ad.totalCount,
          last7DayCount: ad.last7DayCount,
          lastDayCount: ad.lastDayCount,
          orderRate: ad.orderRate,
          price: ad.price,
          majorLevel: ad.majorLevel,
        };
        if (this.adViewType == 100) {
          list.push(ad);
        } else if (this.adViewType == 1) {
          list.push({ ...ad.campainList[0], ...pdInfo });
        } else if (this.adViewType == 2) {
          list.push({ ...ad.campainList[1], ...pdInfo });
        } else if (this.adViewType == 3) {
          ad.campainList[1] && list.push({ ...ad.campainList[1].relateAdverts[0], ...pdInfo });
        } else if (this.adViewType == 4) {
          ad.campainList[1] && list.push({ ...ad.campainList[1].relateAdverts[1], ...pdInfo });
        } else if (this.adViewType == 5) {
          ad.campainList[1] && list.push({ ...ad.campainList[1].relateAdverts[2], ...pdInfo });
        } else if (this.adViewType == 6) {
          ad.campainList[1] && list.push({ ...ad.campainList[1].relateAdverts[3], ...pdInfo });
        }
      });

      // let list = [...this.advertData];
      this.adViewType == 100 &&
        list.forEach(advert => {
          advert.campainList.forEach(ad => (ad.hasChildren = true));
          advert.inventoryCount = parseInt(advert.inventoryCount);
          advert.reservedQuantity = parseInt(advert.reservedQuantity);
          advert.inboundQuantity = parseInt(advert.inboundQuantity);
          advert.inventoryDay = parseInt(advert.inventoryDay);
          advert.availableInventoryDay = parseInt(advert.availableInventoryDay);
        });
      list.sort((a, b) => b.Spend - a.Spend);
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });

      return list;
    },
  },
};
</script>

<style lang="scss">
#AdvertMgmt {
  .header-box {
    text-align: left;
    line-height: 30px;
    padding-left: 10px;
    padding-top: 10px;
    padding-bottom: 10px;

    .el-input,
    .el-select {
      width: 120px;
      margin-right: 15px;
      margin-left: 5px;
      padding: 0px 5px;
    }

    .el-button {
      width: 80px;
    }

    .header-line {
      margin-bottom: 20px;
    }

    .header-line:last-of-type {
      margin-bottom: 0px;
    }

    .small-margin-right {
      margin-right: 5px;
    }

    .header-label {
      font-size: 16px;
    }
  }
  .el-table .cell {
    padding-left: 2px;
    padding-right: 2px;
    line-height: 14px;
    text-align: right;

    .row-item {
      min-height: 14px;
    }

    .redBg {
      background-color: red;
      color: white;
    }
    .yellowBg {
      background-color: yellow;
    }
    .greenBg {
      background-color: green;
      color: white;
    }
    .redText {
      color: red;
    }
    .greenText {
      color: red;
    }
    .greenYellowText {
      color: rgb(233, 104, 104);
    }
    .yellowText {
      color: rgb(112, 56, 56);
    }
  }

  .el-table tr:hover {
    background-color: #f9f981;
  }

  .el-table tr:hover td {
    background-color: transparent;
  }

  .el-table .current-row {
    background-color: #f9f981;

    .el-table__cell {
      background-color: #f9f981;
    }
  }

  .upload-demo {
    text-align: right;
  }
}
</style>
